export default __webpack_public_path__ + "static/media/recognition_inbound.e55de070.png";